import {
  searchApplications,
  SearchApplicationsRequestParams,
} from "@/requests/applications/all-applications.request";
import { useQuery } from "@tanstack/react-query";

/**
 * Builds the base query key for searching applications.
 */
export const buildSearchApplicationsQueryKey = (
  variables: SearchApplicationsRequestParams,
) => ["companies", variables.companyId, "applications"];

export const useSearchApplications = (
  variables: SearchApplicationsRequestParams,
) =>
  useQuery({
    queryKey: [
      ...buildSearchApplicationsQueryKey(variables),
      {
        page: variables.page,
        size: variables.size,
        status: variables.status,
        editionTypes: variables.editionTypes,
        sort: variables.sort,
      },
    ],
    queryFn: () => searchApplications(variables),
    enabled: !!variables.companyId,
  });
